import type { HelpFile } from '../../types/help'
import { InlineAttributeEditorTestIds } from '../../../testids/InlineAttributeEditorTestIds'

export const inlineAttributeEditorHelp: HelpFile = {
  docPage: '/docs/admin/attribute-definitions',
  texts: {
    [InlineAttributeEditorTestIds.inlineAttributeEditor]: 'Edit attribute values directly on the entity — changes are saved per attribute when confirmed.',
    [InlineAttributeEditorTestIds.inlineAttributeEditorRetry]: 'Attribute definitions failed to load — click to retry.',
    [InlineAttributeEditorTestIds.referenceLink]: null,
  },
}
